/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CustomerWalletCardTopupPathParams,
	CustomerWalletCardTopupRequest,
	CustomerWalletCardTopupResponse,
} from '../types/CustomerWalletCardTopup'

/**
 * POST /:organisation/wallet/topup
 * @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::cardTopup
 */
export async function customerWalletCardTopup(
	organisation: CustomerWalletCardTopupPathParams['organisation'],
	data: CustomerWalletCardTopupRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CustomerWalletCardTopupResponse>> {
	return axiosInstance.post(`/${organisation}/wallet/topup`, data, config)
}
